module.exports = __webpack_public_path__ + "img/dw.f1725826.png";